<!--- Reminder: If you are adding a new component, don't forget to register it in index.js --->

-<!--- This component was a mistake. Too complex and too much stuff in a single
-place. The problem was that there wasn't a better way to maintain all the logic
-for validation error text, moving the placeholder text, sending the model, etc.
---->

<template>
  <div class="field" :class="{'date-field' : (type === 'date')}">
    <span id="caret-down" v-if="useAutocomplete || type === 'date'"
          v-bind:class="{icon: true,
                        fas: true,
                        'fa-caret-down': format==='combo',
                        'fa-calendar-alt': type==='date' && !focused}"></span>
    <span id="loader" v-if="isLoading"
          v-bind:class="{icon: true,
                        fas: true,
                        'fa-spinner': true,
                        'fa-spin': true,}"></span>
    <input v-if="type != 'textarea' && type != 'date'"
           :type="type"
           :value="valueData"
           :disabled="disabled || isLoading"
           @input="updateValue($event.target.value)"
           @focus="focus"
           @blur="blur"
           v-on:keyup.enter="onEnter"
           v-on:keyup.down.prevent="onKeyDown"
           v-on:keyup.up.prevent="onKeyUp"
           :class="{'fixed': isNonEmpty}"
           ref="inputField">
    <textarea v-if="type == 'textarea'"
           :value="valueData"
           :disabled="disabled || isLoading"
           @input="updateValue($event.target.value)"
           @focus="focus"
           @blur="blur"
           v-on:keyup.enter="onEnter"
           :class="{'fixed': isNonEmpty}"
           ref="inputField"></textarea>
    <flat-pickr v-if="type === 'date'"
            v-model="valueData"
            :config="flatpickrConfig"
            :disabled="disabled || isLoading"
            @input="$emit('input', valueData)"
            @on-open="focus"
            @on-close="blur"
            :class="{'fixed': isNonEmpty}"
            ref="inputField"></flat-pickr>
    <label :class="{'field-label': true, 'label-disabled': disabled || isLoading}"
           @click="clickOnText">
      {{ labelValue }}
      <span class="error-message"
            v-if="hasBeenFocused || error">
        <span v-if="required && !isNonEmpty">
          {{ label }} is required
        </span>
        <span v-else-if="isNonEmpty && useAutocomplete && !selectedValidOption">
          {{ valueData }} is not a valid option
        </span>
        <span v-else-if="error && !this.errorFixed" class="error-message">
          <span v-for="(e, index) in error" :key="index">
            {{ e }}
          </span>
        </span>
      </span>
    </label>
    <transition name="slide">
      <ul class="autocomplete-menu" ref="autocompleteList" v-if="useAutocomplete && focused && filteredItemsLength > 0">
        <li v-for="(item, index) in filteredItems"
            :key="index"
            @click="select(item)"
            :class="{'active-item': currentSelectedIndex === index}"
            v-on:mouseover="currentSelectedIndex = index">
          {{ item.label }}
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.min.css'

let formatters = {
  zip: {
    update (vm, newValue) {
      if (newValue == null) return newValue
      newValue = newValue.replace(/[^01-9\s-]+/g, '')
      vm.$refs.inputField.value = newValue
      return newValue
    }
  },
  text: {
  },
  date: {
  },
  combo: {
    update (vm, newValue) {
      for (let item of (vm.autoCompleteValuesHidden || vm.autoCompleteValues)) {
        if (typeof (item.value) === 'object') {
          if (item.value.value === newValue) {
            return item.label
          }
        }
        if (item.value === newValue) {
          return item.label
        }
      }
      return newValue
    },
    format (vm, newValue) {
      for (let item of (vm.autoCompleteValuesHidden || vm.autoCompleteValues)) {
        if (typeof (item.value) === 'object') {
          if (item.value.value === newValue) {
            return item.label
          }
        }
        if (item.value === newValue) {
          return item.label
        }
      }
      return newValue
    },
    unformat (vm, newValue) {
      for (let item of (vm.autoCompleteValuesHidden || vm.autoCompleteValues)) {
        if (item.label === newValue) {
          return item.value
        }
      }
      return newValue
    }
  },
  currency: {
    update (vm, newValue) {
      return newValue.replace(/[^01-9$.]+/g, '')
    },
    format (vm, newValue) {
      if (newValue === null) return null
      return '$' + (+newValue / 100).toFixed(2)
    },
    unformat (vm, newValue) {
      if (newValue === null) return null
      return +(('' + newValue).replace(/\$/g, '')) * 100
    }
  },
  percent: {
    update (vm, newValue) {
      return newValue.replace(/[^01-9.]+/g, '')
    },
    format (vm, newValue) {
      if (newValue === null) return null
      return (+newValue / 100).toFixed(2) + '%'
    },
    unformat (vm, newValue) {
      if (newValue === null) return null
      return +(('' + newValue).replace(/%/g, '')) * 100
    }
  }
}

export default {
  name: 'ChcInput',
  props: {
    value: {
      default: ''
    },
    type: {
      default: 'text'
    },
    error: {
      default: null
    },
    format: {
      default: 'text'
    },
    disabled: {
      default: false
    },
    label: {},
    required: {
      default: false
    },
    isLoading: {
      default: false
    },
    autoCompleteValues: {
      default: () => {
        return []
      }
    },
    autoCompleteValuesHidden: {
      default: null
    },
    mustUseAutoCompleteValues: {
      default: true
    },
  },
  components: {
    flatPickr,
  },
  watch: {
    valueData (newValueData) {
      if (this.updateTimes > 0) {
        return
      }
      let dataType = formatters[this.format]
      if (dataType && dataType.hasOwnProperty('unformat')) {
        this.$emit('input', dataType.unformat(this, newValueData))
      } else {
        this.$emit('input', newValueData)
      }
      this.updateTimes = 1
    },
    error (newError) {
      this.errorFixed = false
    },
    filteredItemsLength () {
      this.currentSelectedIndex = 0
    }
  },
  data () {
    return {
      hasBeenFocused: false,
      focused: false,
      valueData: this.value,
      modifiedSinceFocused: false,
      updateTimes: 0,
      errorFixed: false,
      currentSelectedIndex: 0,
      labelValue: this.label,
      flatpickrConfig: {
        // allowInput: true,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'm/d/Y',
      }
    }
  },
  methods: {
    focus () {
      this.hasBeenFocused = false
      this.focused = true
      this.modifiedSinceFocused = false
      this.currentSelectedIndex = 0
      if (this.format === 'combo') this.$refs.inputField.placeholder = this.label
      if (this.type === 'date') {
        this.$refs.inputField.fp._positionElement.placeholder = this.label
        if (!this.value) this.labelValue = ''
      }
    },
    blur () {
      this.updateTimes = 1
      this.hasBeenFocused = true
      this.errorFixed = true
      if (this.format === 'combo') this.$refs.inputField.placeholder = ''
      if (this.type === 'date') {
        this.$refs.inputField.fp._positionElement.placeholder = ''
        this.labelValue = this.label
      }
      this.focused = false
      let dataType = formatters[this.format]
      if (this.valueData !== '' && dataType.hasOwnProperty('format') && dataType.hasOwnProperty('unformat')) {
        this.valueData = dataType.format(this, dataType.unformat(this, this.valueData))
      }
      this.$emit('blur')
    },
    clickOnText () {
      if (this.type === 'date') this.$refs.inputField.fp.open()
      else this.$refs.inputField.focus()
    },
    select (item) {
      this.updateTimes = 0
      this.valueData = item.label
      this.$emit('combo-select', item.value)
    },
    updateValue (value) {
      this.updateTimes = 0
      this.modifiedSinceFocused = true
      if (formatters[this.format].hasOwnProperty('update')) {
        this.valueData = formatters[this.format].update(this, value)
      } else {
        this.valueData = value
      }
    },
    forceUpdateValue (value) {
      this.updateTimes = 1
      this.modifiedSinceFocused = true
      if (formatters[this.format].hasOwnProperty('update')) {
        this.valueData = formatters[this.format].update(this, value)
      } else {
        this.valueData = value
      }
      this.hasBeenFocused = true
      this.errorFixed = true
      this.focused = false
      this.$emit('input', this.valueData)
    },
    onEnter (ev) {
      if (this.format === 'combo' && this.currentSelectedIndex > -1 && this.currentSelectedIndex < this.filteredItemsLength) {
        this.updateValue(this.filteredItems[this.currentSelectedIndex].value)
        this.$emit('enter', this.filteredItems[this.currentSelectedIndex].value)
      } else this.$emit('enter', this)
    },
    onKeyDown () {
      if (this.format === 'combo' && this.currentSelectedIndex < this.filteredItemsLength - 1) {
        this.currentSelectedIndex++
        if (this.$refs.autocompleteList.scrollTop < this.$refs.autocompleteList.children[this.currentSelectedIndex].offsetTop) {
          this.$refs.autocompleteList.scrollTop = this.$refs.autocompleteList.children[this.currentSelectedIndex].offsetTop
        }
      }
    },
    onKeyUp () {
      if (this.format === 'combo' && this.currentSelectedIndex > 0) {
        this.currentSelectedIndex--
        if (this.$refs.autocompleteList.scrollTop > this.$refs.autocompleteList.children[this.currentSelectedIndex].offsetTop) {
          this.$refs.autocompleteList.scrollTop = this.$refs.autocompleteList.children[this.currentSelectedIndex].offsetTop
        }
      }
    },
  },
  mounted () {
    let dataType = formatters[this.format]
    if (this.value !== '' && this.value !== null && dataType.hasOwnProperty('format')) {
      this.valueData = dataType.format(this, this.value)
    } else {
      this.valueData = this.value
    }
  },
  updated () {
    if (this.updateTimes === 1) {
      return
    }
    if (this.valueData === this.value) {
      return
    }
    this.valueData = this.value
    if (!this.focused) {
      let dataType = formatters[this.format]
      if (dataType.hasOwnProperty('format')) {
        this.valueData = dataType.format(this, this.value)
      } else {
        this.valueData = this.value
      }
    }
  },
  computed: {
    useAutocomplete () {
      return this.autoCompleteValues.length > 0
    },
    isNonEmpty () {
      return !!(this.value || (this.valueData && this.valueData.toString().length > 0) || this.type === 'time')
    },
    filteredItems () {
      if (this.format !== 'combo') {
        return []
      }
      if (this.format === 'combo' && !this.modifiedSinceFocused) {
        return this.autoCompleteValues
      }
      if (!this.focused || this.valueData === null) {
        return this.autoCompleteValues
      }
      return this.autoCompleteValues.filter((item) => {
        let words = this.valueData.toLowerCase().split(' ')
        while (words.length) {
          let word = words.pop()
          if (item.label.toLowerCase().indexOf(word) === -1) {
            return false
          }
        }
        return true
      })
    },
    filteredItemsLength () {
      if (this.format === 'combo' && this.focused) return this.filteredItems.length
      return 0
    },
    selectedValidOption () {
      if (!this.mustUseAutoCompleteValues) {
        return true
      }
      return (this.autoCompleteValuesHidden || this.autoCompleteValues).some((item) => {
        return item.label === this.valueData
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/variables";

:not(.fixed) .field-label {
    cursor: text;
}

#caret-down {
    position: absolute;
    top: .25rem;
    right: .25rem;
}

#loader {
    position: absolute;
    top: 25%;
    right: 50%;
    color: $lt-grey;
}

.autocomplete-menu {
    position: absolute;
    top: 1.7rem;
    right: 0;
    background-color: #ffffff;
    /* border-top: 2px solid $yellow; */
    border-radius: 0 0 .25rem .25rem;
    box-shadow: 0 3px 10px $dark-grey;
    padding: 0;
    list-style-type: none;
    margin: 0;
    width: 100%;
    z-index: 100;
    text-align: left;
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
    &:before {
        content: '';
        display: block;
        height: 3px;
        position: absolute;
        top: -5px;
        width: 100%;
        left: -1px;
    }
    li {
        margin: 0;
        padding: .50rem;
        display: block;
    }
}
.active-item {
  background: $light-blue;
}

.slide-enter-active, .slide-leave-active {
    transition: opacity .25s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
    opacity: 0;
}

.label-disabled {
    color: $lt-grey !important
}

</style>



// WEBPACK FOOTER //
// src/components/Widgets/ChcInput.vue